import { useLocation, useSearchParams } from 'react-router-dom';
import { HIDE_TABBAR_PARAM } from '../constant';

export const useIsTabbarHidden = (): boolean => {
    const { pathname } = useLocation();
    const [query] = useSearchParams();

    const isCollectionPage = pathname.startsWith('/collections/');
    const isPostProductsPage = /^\/posts\/[^/]+\/products$/.test(pathname);
    const hideTabbarParam = query.get(HIDE_TABBAR_PARAM) === '1';

    return isCollectionPage || isPostProductsPage || hideTabbarParam;
};
